import { Component, EventEmitter, Output } from '@angular/core';
import { assets } from '../../../../core/constants/assets.const';

@Component({
  selector: 'logibids-available-vehicle-info',
  imports: [],
  templateUrl: './available-vehicle-info.component.html',
  styleUrl: './available-vehicle-info.component.scss',
})
export class AvailableVehicleInfoComponent {
  readonly assets = assets;
  @Output() closeInfo = new EventEmitter<void>();

  onClose() {
    this.closeInfo.emit();
  }
}
